// extracted by mini-css-extract-plugin
module.exports = {"hover-only":"_1hErn","hoverOnly":"_1hErn","hover-only-and-collapsed":"EcG2H","hoverOnlyAndCollapsed":"EcG2H","hoverable":"Y-DVc"};